module.exports = __webpack_public_path__ + "img/background.2818686f.jpg";